<template>
  <ServicePageLayout
    title="Hot Water"
    subtitle="ระบบน้ำร้อน"
    icon="mdi-hot-tub"
    icon-color="warning"
    breadcrumb="Operations"
    :available="sanitary_machine.length > 0"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab v-if="main_level.length > 0 || main_meter.length > 0">Dashboard</v-tab>
      <v-tab v-if="main_level.length > 0 || main_meter.length > 0">History</v-tab>
      <v-tab>Machine</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-if="main_level.length > 0 || main_meter.length > 0">
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="main_level.length > 0 || main_meter.length > 0">
        <v-card flat class="service-content-panel">
          <v-card-text><Table /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MACHINE_VIEW :assets="sanitary_machine" /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Dashboard from '@/components/hot/sanitary_dashboard'
import Table from '@/components/hot/sanitary_table'
import MACHINE_VIEW from '@/components/machine/machine_view'

export default {
  name: 'HotWaterView',
  components: {
    ServicePageLayout,
    Dashboard,
    Table,
    MACHINE_VIEW
  },
  computed: {
    main_meter() {
      return this.$store.state.HotWater.mainWaterMeter
    },
    main_level() {
      return this.$store.state.HotWater.mainWaterLevel
    },
    sanitary_machine() {
      return this.$store.state.Asset.assetAll.filter(
        el => el.machine === true && el.serviceId === 'a07187f5-c788-42f5-8285-8cd5e9c99c0f'
      )
    }
  },
  data() {
    return { tab: null }
  },
}
</script>
